import { render } from "./ProjectSection.vue?vue&type=template&id=6250520a&scoped=true"
import script from "./ProjectSection.vue?vue&type=script&lang=js"
export * from "./ProjectSection.vue?vue&type=script&lang=js"

import "./ProjectSection.vue?vue&type=style&index=0&id=6250520a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6250520a"]])

export default __exports__